import React from "react"
import {Button, Modal} from "antd"
import {useTranslation} from "react-i18next"

const PriceDetails = (props) => {
    const {ptmInfo, setPtmInfo} = props
    const {t} = useTranslation(['common', 'nri', 'action', 'kit'])

    function handleDescriptionCancel() {
        setPtmInfo({visible: false, record: null})
    }

    return (
        <Modal
            title={`ПТМ ${ptmInfo.record.code}`}
            open={ptmInfo.visible}
            destroyOnHidden
            onCancel={handleDescriptionCancel}
            footer={[
                <Button
                    key="save"
                    //loading={isSending}
                    onClick={handleDescriptionCancel}
                >
                    Ok
                </Button>
            ]}
        >
            {/*<TextArea value={ptmInfo.record.ptmDescription} autoSize={{minRows: 20, maxRows: 40}} /> */}
            <p>{`Название: ${ptmInfo.record.name}`}</p>
            {
                ptmInfo.record.ptmDescription && <p>{`Описание: ${ptmInfo.record.ptmDescription}`}</p>
            }
            {
                ptmInfo.record.priceDetails && <>
                    <p>{`Объем ПТМ: ${ptmInfo.record.priceDetails.volume} ${ptmInfo.record.measureUnit}`}</p>
                    <p>{`Заработная плата: ${ptmInfo.record.priceDetails.pay}`}</p>
                    <p>{`Трудоемкость: ${ptmInfo.record.priceDetails.lc}`}</p>
                    <p>{`Эксплуатация машин: ${ptmInfo.record.priceDetails.omach}`}</p>
                    <p>{`В том числе заработная плата рабочего(эксплуатация машин): ${ptmInfo.record.priceDetails.iPay}`}</p>
                    <p>{`Материалы: ${ptmInfo.record.priceDetails.matt}`}</p>
                    <p>{`Транспорт (материалы): ${ptmInfo.record.priceDetails.trm}`}</p>
                    <p>{`Оборудование: ${ptmInfo.record.priceDetails.eqp}`}</p>
                    <p>{`Транспорт (оборудования): ${ptmInfo.record.priceDetails.tre}`}</p>
                    <p>{`ОХР и ОПР: ${ptmInfo.record.priceDetails.oo}`}</p>
                    <p>{`Плановая прибыль: ${ptmInfo.record.priceDetails.pp}`}</p>
                    <p>{`Прочие затраты: ${ptmInfo.record.priceDetails.oc}`}</p>
                    <p>{`Итого: ${ptmInfo.record.sum} руб.`}</p>
                </>
            }
            {
                ptmInfo.record.limited && <p>{`Лимитированные затраты: ${ptmInfo.record.limited.value} руб.`}</p>
            }
        </Modal>
    )
}
export default PriceDetails